var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.822 10l-4.41-4.41A.833.833 0 115.59 4.41L10 8.823l4.411-4.411a.833.833 0 111.179 1.178L11.179 10l4.41 4.41a.833.833 0 01-1.178 1.18l-4.41-4.411-4.411 4.41a.833.833 0 11-1.179-1.178L8.821 10z",
    fill: "#42526E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "close-icon2_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.822 10l-4.41-4.41A.833.833 0 115.59 4.41L10 8.823l4.411-4.411a.833.833 0 111.179 1.178L11.179 10l4.41 4.41a.833.833 0 01-1.178 1.18l-4.41-4.411-4.411 4.41a.833.833 0 11-1.179-1.178L8.821 10z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#close-icon2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20h20V0H0v20z",
    fill: "#6D6E71"
  }))));
}
export default SvgCloseIcon2;